'use client';

import { initAmplitude } from '@/utils/amplitude';
import { useEffect } from 'react';

export default function AmplitudeClient() {
  useEffect(() => {
    initAmplitude();
  }, []);

  return null;
}
